import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Markdown from 'client/components/aria/MarkDown/Markdown';
import { CMSService } from 'client/services';
import { useLocaleAutoSwitch } from 'i18n/localeUtils';
import styles from './HelpTab.module.scss';
import RRDNavLink from 'client/components/aria/NavLink/NavLink';
import { HELP_PAGE } from 'client/utils/routes/routeConstants';
import Icon from '@mdi/react';
import { mdiOpenInNew } from '@mdi/js';
import LoadingScreen from 'client/components/suc/LoadingScreen/LoadingScreen';

const HelpTab = () => {
    useLocaleAutoSwitch();
    const LOADING = 'LOADING';
    const [content, setContent] = useState(LOADING);

    useEffect(() => {
        CMSService.getHelp().then(setContent);
    }, []);

    const openHelpTab = (e) => {
        e.preventDefault();
        const url = e.currentTarget.href;
        window.open(url, '_blank');
    };

    return <>
        <div className={styles.openButton}>
            <RRDNavLink
                className={['govuk-button', styles.openButton].join(' ')}
                to={HELP_PAGE} onClick={openHelpTab}
                rel="noopener noreferrer nofollow"
                data-testid={'helpTab.openNewHelpTab'}
            >
                <FormattedMessage id="mapTabs.help.button.description"/>
                <Icon path={mdiOpenInNew} size={0.8} className={styles.icon}/>
            </RRDNavLink>
        </div>
        <div className={styles.helpContent}>
            {content === LOADING
                ? <LoadingScreen delay />
                : <Markdown>{content?.markdown}</Markdown>
            }
        </div>
    </>;
};

export default HelpTab;
